// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-8dd02f40]::placeholder{color:var(--colorGrayDarker)}@media screen and (min-width:1024px) and (max-width:1215px){input[data-v-8dd02f40]::placeholder{font-size:var(--fontSizeXs)}}.focus-glow[data-v-8dd02f40]{animation:glow-8dd02f40 .5s linear 0s infinite alternate;box-shadow:0 0 0 2px var(--colorInfo)}@keyframes glow-8dd02f40{0%{box-shadow:0 0 0 2px var(--colorInfo)}to{box-shadow:0 0 0 3px var(--colorInfo)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
